module.exports = {
  loginRedirect: process.env.REACT_APP_LOGIN_REDIRECT,
  apiUrl: process.env.REACT_APP_API_URL,
  generalApiUrl: process.env.REACT_APP_API_GENERAL_URL,
  whatsappToken: process.env.REACT_APP_WHATSAPP_TOKEN,
}
